/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Linkify from '../../../text/Linkify';
import { countWords, truncateString } from '../../../../utils';
import Location from '../../Location';
import OrganizerCard from '../../../cards/OrganizerCard';
import withAuth from '../../../hocs/withAuth';
import {
    sendMessageToPlayers,
    showAdminSplash,
} from '../../../../actions/event-actions';
import * as messagingActions from '../../../../actions/messaging-actions';
import PlayersList from './PlayersList';

import styles from '../../../../pages/EventProfiles/event.scss';

function CreatePlayHeader(props) {
    const { auth, msgSetNewConv, msgAddRecipient, events, history } = props;
    const { currentEvent = {} } = events;
    const { data: event } = currentEvent;
    const [descriptionExpanded, setDescriptionExpanded] = useState(false);

    const sendMessage = (recipient) => {
        if (recipient?.memberId && auth?.user?.id !== recipient.memberId) {
            msgSetNewConv(true);
            msgAddRecipient(recipient);
            history.push(`/inbox`);
        }
    };

    return (
        <div className={`${styles.section} main-content`}>
            <div className={`container pb0`}>
                <div className="row">
                    <div className="col-md-8">
                        {event && event.details && (
                            <React.Fragment>
                                <h6 className="text-uppercase">
                                    Event Notes
                                </h6>
                                <Linkify>
                                    <div>
                                        {countWords(event.details) < 200 && (<p className="text-line-break">{event.details}{/* <Markdown markup={event.details} /> */}</p>)}
                                        {countWords(event.details) >= 200 && (
                                            <p className="text-line-break">
                                                {descriptionExpanded ? event.details : truncateString(event.details, 200)}
                                                <span
                                                    className={`${styles.readMore}`}
                                                    onClick={() => {
                                                        setDescriptionExpanded(!descriptionExpanded);
                                                    }}
                                                >
                                                    {descriptionExpanded ? 'Read less' : 'Read more'}
                                                </span>
                                            </p>
                                        )}
                                    </div>
                                </Linkify>
                            </React.Fragment>
                        )}
                        <PlayersList
                            event={event}
                        />
                    </div>
                    <div className="col-md-4">
                        <h6 className="text-uppercase">Organizer</h6>
                        <div className="club-details">
                            {event && event.eventDirectors.map((director, i) => (
                                <OrganizerCard
                                    key={`organizer-${i}`}
                                    organizer={director}
                                    user={auth.user}
                                    sendMessage={sendMessage}
                                />
                            ))}
                        </div>
                        <h6 className="text-uppercase">Location</h6>
                        <Location
                            event={event}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapDispatchToProps(dispatch) {
    return {
        sendMessageToPlayers: (message, eventId, drawId, sendCopyToOrganizer) => {
            dispatch(sendMessageToPlayers(message.replace(/(?:\r\n|\r|\n)/g, '<br>'), eventId, drawId, sendCopyToOrganizer));
        },
        msgAddRecipient: member => dispatch(messagingActions.addRecepient({ member })),
        msgSetNewConv: member => dispatch(messagingActions.setNewConv({ member })),
        showAdminSplash: data => dispatch(showAdminSplash(data)),
    };
}

function mapStateToProps({ auth, events, coreUI }) {
    return { auth, events, coreUI };
}

export default withRouter(withAuth(connect(mapStateToProps, mapDispatchToProps)(CreatePlayHeader)));
